// Du fait d'une limitation d'angularJS et de blocks.smart.table
// le controller doit être déclaré comme une fonction et non une classe
// on injecte donc directement les dépendances dans la fonction comme le veut angularJS
/* @ngInject */
export default function RepTabulatorController($translate, registresLegacyService, DataShareService, $state) {
	const vm = this;

	vm.$translate = $translate;
	vm.$state = $state;
	vm.registresLegacyService = registresLegacyService;
	vm.DataShareService = DataShareService;

	vm.initServerGridConfig = initServerGridConfig;
	vm.gridApi = {};

	async function init() {
		await vm.initServerGridConfig();
	}

	vm.$onInit = () => {
		vm.tabulatorApi = vm.gridApi;
		init();
	};

	vm.$onDestroy = () => {};

	async function initServerGridConfig() {
		// On récupère la config auprès du service
		vm.serverConfig = await vm.registresLegacyService.getGridConfig();

		// On initialise le composant générique avec cette config
		vm.serverConfig = await vm.gridApi.initServerGridConfig({
			configFn: () => Promise.resolve(vm.serverConfig)
		});
	}
}
